import { format, isValid, parse } from 'date-fns';

// QC Serum and QC Isolate/SS+ are text columns in OvaDrive (tog_qcserum /
// tog_qcisolate), unlike the other QC expiration dates. The date picker stores
// them as MM/DD/YYYY text so existing reports keep reading them as before (#38123).
const QC_TEXT_DATE_FORMAT = 'MM/dd/yyyy';

export const toQcDateText = (date: Date | null | undefined): string =>
  date && isValid(date) ? format(date, QC_TEXT_DATE_FORMAT) : '';

/** Date for the picker, or undefined when the text is empty or not MM/DD/YYYY. */
export const fromQcDateText = (text: string): Date | undefined => {
  if (!text) return undefined;
  const date = parse(text, QC_TEXT_DATE_FORMAT, new Date());
  return isValid(date) ? date : undefined;
};
